export const BUTTONS = {
  REPEAT_LAST: 'Repeat Last',
  CHOOSE_OPTIONS: 'Choose',
};
